import {useProfile} from "@brg/auth";
import {FC, useCallback, useMemo, useState} from "react";
import {API, Endpoints, Lang, Team, TeamAPI} from "@brg/api";
import styled from "styled-components";
import {Colors, Skeleton} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {createEmptyLangObject} from "../../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {CreateLinkTo} from "../../../../constants/linkTo";
import {useHistory} from "react-router-dom";
import {useGetPersonalChannel} from "../../../../hooks/api/useGetPersonalChannel";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DRAFT_TEAM_STATUS } from "shared/helpers/teamsStatus";

const Button  = styled.div<{disabled?: boolean, isChannelCreated?: boolean}>`
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: ${({isChannelCreated}) => isChannelCreated ? Colors.galBlack100 : Colors.geoWhite100};
    border: 1px solid #909090;
    color: ${({isChannelCreated}) => isChannelCreated ? Colors.geoWhite100 : Colors.galBlack100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: 270px;

    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 460px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
            width: 348px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        height: 28px;
        width: 128px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 100%;
        font-weight: 700;
    }
`

export const CreateChannelButton: FC<{ designerId: string, isMe?: boolean }> = ({ designerId, isMe }) => {
    const profile = useProfile()
    const [isChannelLoading, setIsChannelLoading] = useState(false)
    const { t, i18n: { language} } = useTranslation()
    const history = useHistory();
    const {channelsInfo, isLoading} = useGetPersonalChannel(designerId || '');

    const channel = useMemo(() => {
        if (isLoading) return null
        return channelsInfo?.personalChannel || null
    } , [channelsInfo, isLoading])

    const onUpdateChannelStatus = async (id: string) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": id,
            "status": DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
    }

    const onClick = useCallback(() => {

        if (isLoading || isChannelLoading) return

        if (!channel) {
            setIsChannelLoading(true)
            TeamAPI.Add({
                name: createEmptyLangObject('', ['ru', 'en']),
                initialTab: '',
                ownersIDs: [profile?.accountId || ''],
                moderationType: ModerationType.Channel,
            } as Team<'Global'> & any)
                .then((res) => res.json())
                .then((teamId: any) => {
                    onUpdateChannelStatus(teamId)
                    setTimeout(() => {
                        history.replace(CreateLinkTo.teamEdit(teamId));
                        setIsChannelLoading(false)
                    }, 800);
                });
            return;
        }

        history.push('/teams/' + channel?.teamId)

    }, [isLoading, isChannelLoading, channel, history, profile?.accountId])

    if (isLoading || isChannelLoading) {
        return (
            <Skeleton height={20} width={150} />
        )
    }

    if (!!channel || !designerId || (designerId !== profile?.accountId)) return null;

    return <Button disabled={isChannelLoading || isLoading} isChannelCreated={!!channel} onClick={onClick}>
        {t('subscription.create_channel')}
    </Button>
}import {useProfile} from "@brg/auth";
import {FC, useCallback, useMemo, useState} from "react";
import {API, Endpoints, Lang, Team, TeamAPI} from "@brg/api";
import styled from "styled-components";
import {Colors, Skeleton} from "@brg/ui";
import {LayoutConst} from "../../../../../core";
import {useTranslation} from "react-i18next";
import {createEmptyLangObject} from "../../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {CreateLinkTo} from "../../../../constants/linkTo";
import {useHistory} from "react-router-dom";
import {useGetPersonalChannel} from "../../../../hooks/api/useGetPersonalChannel";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { DRAFT_TEAM_STATUS } from "shared/helpers/teamsStatus";

const Button  = styled.div<{disabled?: boolean, isChannelCreated?: boolean}>`
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: ${({isChannelCreated}) => isChannelCreated ? Colors.galBlack100 : Colors.geoWhite100};
    border: 1px solid #909090;
    color: ${({isChannelCreated}) => isChannelCreated ? Colors.geoWhite100 : Colors.galBlack100};
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    border-radius: 3px;
    width: 270px;

    @media(max-width: ${LayoutConst.screen.l}px) {
        width: 460px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
            width: 348px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 13px;
        line-height: 16px;
        height: 28px;
        width: 128px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 100%;
        font-weight: 700;
    }
`

export const CreateChannelButton: FC<{ designerId: string, isMe?: boolean }> = ({ designerId, isMe }) => {
    const profile = useProfile()
    const [isChannelLoading, setIsChannelLoading] = useState(false)
    const { t, i18n: { language} } = useTranslation()
    const history = useHistory();
    const {channelsInfo, isLoading} = useGetPersonalChannel(designerId || '');

    const channel = useMemo(() => {
        if (isLoading) return null
        return channelsInfo?.personalChannel || null
    } , [channelsInfo, isLoading])

    const onUpdateChannelStatus = async (id: string) => {
        return await API.request('/api/Team/UpdateStatus')
        .endpoint(Endpoints.geograffee)
        .post()
        .body({
            "teamId": id,
            "status": DRAFT_TEAM_STATUS
        })
        .send()
        .then((r) => r)
    }

    const onClick = useCallback(() => {

        if (isLoading || isChannelLoading) return

        if (!channel) {
            setIsChannelLoading(true)
            TeamAPI.Add({
                name: createEmptyLangObject('', ['ru', 'en']),
                initialTab: '',
                ownersIDs: [profile?.accountId || ''],
                moderationType: ModerationType.Channel,
            } as Team<'Global'> & any)
                .then((res) => res.json())
                .then((teamId: any) => {
                    onUpdateChannelStatus(teamId)
                    setTimeout(() => {
                        history.replace(CreateLinkTo.teamEdit(teamId));
                        setIsChannelLoading(false)
                    }, 800);
                });
            return;
        }

        history.push('/teams/' + channel?.teamId)

    }, [isLoading, isChannelLoading, channel, history, profile?.accountId])

    if (isLoading || isChannelLoading) {
        return (
            <Skeleton height={20} width={150} />
        )
    }

    if (!!channel || !designerId || (designerId !== profile?.accountId)) return null;

    return <Button disabled={isChannelLoading || isLoading} isChannelCreated={!!channel} onClick={onClick}>
        {t('subscription.create_channel')}
    </Button>
}